<template>
    <div>
        <img class="example-headImg" src="../../assets/image/technicalService/04-3-5banner.png"/>
        <div class="head-explain">
            <div class="head-explain-title">快速交付平台</div>
            <div class="head-explain-content">旨在帮助大型传统企业克服数字化转型过程中面临的各种挑战，</div>
            <div class="head-explain-content" style="margin-top:-3rem">可以简单，快速，高效地开发出企业级的应用系统。</div>
        </div>
        <div class="custom-head-list">
            <div class="box">
                <div class="custom-list-item custom-list-ischeck" @click="goAssignBlock('block'+ 0,50)"><span class="title">总览</span></div>
                <div class="custom-list-item" @click="goAssignBlock('block'+ 1,50)"><span class="title">特点</span></div>
                <div class="custom-list-item" @click="goAssignBlock('block'+ 2,50)"><span class="title">优势</span></div>  
            </div>  
        </div>
        <div class="container-1" ref="block0">
            <div class="custom-box1" style="margin-bottom:5.8rem">
                <div class="title1">总览</div>
                <div class="title2">通过快速交付平台，企业业务部门可直接通过配置实现包含表单、流程、报表等业务功能。此外，我们提供了包括组织架构、
                    权限体系、认证授权等系统功能和流媒体、IM、在线文档等高级功能，使得企业可以免去企业应用基础功能的开发，而专注实现业务功能。<br/>
                    针对业务功能的开发，我们产品还提供了需求、开发、测试规范，并提供基于开发规范的IDE检查插件及代码扫描插件。<br/>
                    除了对企业信息系统功能性需求的支持，我们产品还为企业提供了基于云计算的监控预警、日志分析、高可用、系统容灾、本地系统上云等企业
                    级解决方案以保证系统合规、可靠、高效。</div>
                <img class="img1" src="../../assets/image/technicalService/04-3-5总览.png"/>
            </div>
        </div>
        <div class="container-2" style="display:flex;height: 44rem;" ref="block1">
            <div class="custom-box1" style="margin-top:0rem;">
                <div class="title1">特点</div>
                <div>
                    <div class="box2-1" style="margin-top:2.4rem">
                        <div class="big-card">
                            <div class="card">
                                <img src="../../assets/image/technicalService/04-3-5见即所得.svg"/>
                                <div class="title2-1">见即所得</div>
                                <div class="title2-2">丰富的表单组件 ,  帮助企业用户以简单拖拽即可生成自定义表单页面 ,  轻松实现业务数据定义。</div>
                            </div>
                        </div> 
                        <div class="big-card">
                            <div class="card">
                                <img src="../../assets/image/technicalService/04-3-1蓝图设计.svg"/>
                                <div class="title2-1">流程定制便捷</div>
                                <div class="title2-2">可视化流程设计，支撑业务流程的高效流转。</div>
                            </div>
                        </div>
                        <div class="big-card"> 
                            <div class="card">
                                <img src="../../assets/image/technicalService/04-3-1系统演示.svg"/>
                                <div class="title2-1">业务事件清晰全面</div>
                                <div class="title2-2">将机械化重复工作打包成可配置式的业务功能，配合系统提供的APl，简化复杂业务流程下的功能实现。</div>
                            </div>
                        </div>   
                        <div class="big-card"> 
                            <div class="card">
                                <img src="../../assets/image/technicalService/04-3-1功能确认.svg"/>
                                <div class="title2-1">权限配置完善</div>
                                <div class="title2-2">提供基于系统角色、业务角色、多层级组织多租户等管理方式，以及细化到应用、页面、表单、字段等多维度数据权限管控，实现权限的精细化管理。</div>
                            </div>
                        </div>
                        <div class="big-card"> 
                            <div class="card">
                                <img src="../../assets/image/technicalService/04-3-1功能确认.svg"/>
                                <div class="title2-1">二次开发灵活</div>
                                <div class="title2-2">Amazon云原生基础架构，支持以原生方式进行二次开发和插件式功能的扩展，具备良好的集成特性，并可搭配加速器，延展更为出色的集成能力。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-1" style="margin-bottom:10rem" ref="block2">
            <div class="custom-box1" style="margin-top:0rem;">
                <div class="title1">优势</div>
                <div>
                    <div class="box2-2" style="margin-top:2.4rem"> 
                        <div class="card" style="background-color:#F3FAF6;">
                            <img src="../../assets/image/technicalService/04-3-5统一业务.svg" style="width:5rem;height:5rem"/>
                            <div class="content">
                                <div class="title1">统一业务认知</div>
                                <div class="title2">基于可视化应用程序开发环境 ,  借助表单工具、流程设计和报表设计等模块 , 业务人员和技术人员能快速达成业务统   一理解 , 
                                    在降低沟通成本的同时能快速完成从业务构想到系统落地的完整闭环。</div>
                            </div>
                            
                        </div>
                        <div class="card" style="background-color:#F9F9F9;">
                            <img src="../../assets/image/technicalService/04-3-5多样化.svg"/>
                            <div class="content">
                                <div class="title1">满足多样化需求</div>
                                <div class="title2">平台通过组件搭建的模式构建系统 ,  可以满足企业不同阶段的数字化需求 ,  契合企业当下的业务探索的诉求 ，
                                    保障企业的长期竞争力。</div>
                            </div>
                            
                        </div>
                        <div class="card" style="background-color:#F9F9F9;margin-top: 1rem;">
                            <img src="../../assets/image/technicalService/04-3-5低成本.svg"/>
                            <div class="content">
                                <div class="title1">低成本和高效率</div>
                                <div class="title2">和传统开发模式相比 ,  比孚快速交付平台极大程度的降低了业务系统搭建的人工成本 ,  缩短了开发周期。没有技
                                    术背景的用户也能通过平台提供的可视化 的应用搭建系统完成简单业务系统的搭建。</div>
                            </div>
                            
                        </div>
                        <div class="card" style="background-color:#F3FAF6;margin-top: 1rem;">
                            <img src="../../assets/image/technicalService/04-3-5挖掘数据.svg"/>
                            <div class="content">
                                <div class="title1">挖掘数据资产</div>
                                <div class="title2">比孚快速交付平台信息存储模型具有高度一致性 ,  标准化接口完成企业内多套业务系统数据集成,打破企业内信息孤岛
                                    。在统一的数据存储基础上,  管理人员可以快速从企业各类业务数据完成关联关系建立,更好地挖掘企业本身业务潜力。</div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'BizfocusPagesPurchaseCollaboration',
    metaInfo:{
        meta:[
        { name:'keywords', content:'快速交付平台,见即所得,流程定制便捷,业务事件清晰全面,权限配置完善,二次开发灵活,统一业务认知,满足多样化需求,低成本和高效率,挖掘数据资产' },
        { name:'description', content:'通过快速交付平台，企业业务部门可直接通过配置实现包含表单、流程、报表等业务功能。此外，我们提供了包括组织架构、 权限体系、认证授权等系统功能和流媒体、IM、在线文档等高级功能，使得企业可以免去企业应用基础功能的开发，而专注实现业务功能。针对业务功能的开发，我们产品还提供了需求、开发、测试规范，并提供基于开发规范的IDE检查插件及代码扫描插件。除了对企业信息系统功能性需求的支持，我们产品还为企业提供了基于云计算的监控预警、日志分析、高可用、系统容灾、本地系统上云等企业 级解决方案以保证系统合规、可靠、高效' }
        ]
    },
    data() {
        return {
            checkIndex:1,
            activeIndex:'4',
            navOffsetTop: 0,
        };
    },

    mounted() {
        this.activeIndex = '4'
        this.newsIndex = false
        this.refreshIndexInfo({
            data:this.activeIndex ,
            news:this.newsIndex
        });
        // 监听滚动事件
        window.addEventListener('scroll', this.fiexdNav)
        this.getData()
    },
    destroyed () {
        // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
        window.removeEventListener('scroll', this.fiexdNav)
    },
    methods: {
        ...mapActions([
            'refreshIndexInfo'
        ]),
        jumpRout(route,index){
            this.activeIndex = index
            localStorage.setItem('headId',index);
            this.$router.push(route)
        },
        goAssignBlock(el, speed) {
            const navHeight = document.querySelector('.custom-head-list').offsetHeight
            let _this = this;
            let windowH = window.innerHeight; //浏览器窗口高度
            let h = this.$refs[el].offsetHeight; //模块内容高度
            let t = this.$refs[el].offsetTop; //模块相对于内容顶部的距离
            let top = t; //需要滚动到的位置，若改为 t 则滚动到模块顶部位置，此处是滚动到模块相对于窗口垂直居中的位置
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop; //滚动条距离顶部高度
            let currentTop = scrollTop; //默认滚动位置为当前滚动条位置，若改为0，则每次都会从顶部滚动到指定位置
            let requestId;
            //采用requestAnimationFrame，平滑动画
            function step() {
                //判断让滚动条向上滚还是向下滚
                if (scrollTop < top) {
                if (currentTop <= top) {
                    //   window.scrollTo(x,y) y为上下滚动位置
                    window.scrollTo(0, currentTop - navHeight -100);
                    requestId = window.requestAnimationFrame(step);
                } else {
                    window.cancelAnimationFrame(requestId);
                }
                //向下滚动
                currentTop += speed;
                } else {
                if (top <= currentTop) {
                    //注：此处 - speed 是解决居中时存在的问题，可自行设置或去掉
                    window.scrollTo(0, currentTop - speed - navHeight);
                    requestId = window.requestAnimationFrame(step);
                } else {
                    window.cancelAnimationFrame(requestId);
                }
                //向上滚动
                currentTop -= speed;
                }
            }
            window.requestAnimationFrame(step);
        },
        /** 设置导航条nav到达页面顶部时固定 **/
        // 1.获取导航条nav的offsetTop值，存储在data中（注：之所以不放在滚动事件中，是为了以防添加固定样式后offsetTop值为零,导致页面需要滚动到最上面才可以回到原位）
        getData () {
            this.navOffsetTop = document.querySelector('.custom-head-list').offsetTop + 60
            console.log('this.navOffsetTop',this.navOffsetTop)
        },
        fiexdNav () {
            // 2.获取当前页面的卷曲高度
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            const nav = document.querySelector('.custom-head-list')
            // 3.判断卷曲高度是否大于等于导航条的offsetTop值
            if (scrollTop > this.navOffsetTop) {
                //   3.1若满足，则给nav导航添加固定样式
                nav.classList.add('fixedNav')
            } else {
                //   3.2若不满足，则删除nav导航的固定样式
                nav.classList.remove('fixedNav')
            }

            /** 当滚动到一定区域时给导航项添加选中样式 **/
            //  1.获取所有锚点元素
            let contents = document.querySelectorAll('.container-1>div')
            // contents = this.$refs[el]
            console.log('1111',this.$refs['block0'].offsetTop)
            // 2.获取锚点元素的offsetTop值，并收集在一个数组
            const contentsOffsetTop = []
            // contents.forEach(item => {
            //     contentsOffsetTop.push(item.offsetTop)
            //     console.log('2222',item.offsetTop)
            // })
            contentsOffsetTop.push(this.$refs['block0'].offsetTop)
            contentsOffsetTop.push(this.$refs['block1'].offsetTop)
            contentsOffsetTop.push(this.$refs['block2'].offsetTop)
            // 3.获取页面高度
            const pageHeight = window.innerHeight
            // 4.获取nav的子元素
            const navChildren = document.querySelectorAll('.custom-head-list .custom-list-item')
            for (let j = 0; j < contentsOffsetTop.length; j++) {
                    navChildren[j].classList.remove('custom-list-ischeck')
                    navChildren[0].classList.add('custom-list-ischeck')
                }
            if(scrollTop>1000){
                for (let j = 0; j < contentsOffsetTop.length; j++) {
                    navChildren[j].classList.remove('custom-list-ischeck')
                    navChildren[1].classList.add('custom-list-ischeck')
                }
            }
            if(scrollTop>1500){
                for (let j = 0; j < contentsOffsetTop.length; j++) {
                    navChildren[j].classList.remove('custom-list-ischeck')
                    navChildren[2].classList.add('custom-list-ischeck')
                }
            }
            // 5.遍历锚点元素的offsetTop值
            // for (let i = 0; i < contentsOffsetTop.length; i++) {
            //     // 5.1 设置第一项导航默认为选中状态
            //     if (i === 0) {
            //     navChildren[0].classList.add('custom-list-ischeck')
            //     } else if (scrollTop > contentsOffsetTop[i - 1] + pageHeight / 3) {
            //     // 排他思想
            //     for (let j = 0; j < contentsOffsetTop.length; j++) {
            //         navChildren[j].classList.remove('custom-list-ischeck')
            //         navChildren[i].classList.add('custom-list-ischeck')
            //     }
            //     } else {
            //     navChildren[i].classList.remove('custom-list-ischeck')
            //     }
            // }
        },
        /**
         *设置点击导航跳转到指定选择器对应的锚点元素
        * @param {*} selector
        **/
        skipTo (selector) {
            const navHeight = document.querySelector('.custom-head-list').offsetHeight
            // scrollIntoView() js原生方法，实现锚点滚动过渡
            const target = document.querySelector(selector)
            target.scrollIntoView({ behavior: 'smooth' })
            // scrollTo() 把内容滚动到指定的坐标。减去导航高度的目的：导航用定位固定在顶部，如果不减去，导航栏会遮挡一部分内容
            window.scrollTo(0, target.offsetTop - navHeight)
        }
    },
};
</script>

<style lang="less" scoped>
.custom-head-list{
    width: 190rem;
    border-bottom: 2px solid #F8F8F8;
    height: 7.9rem;
    display: flex;
    .box{
        width: 139rem;
        margin: auto;
        display: flex;
    }
}
.custom-list-item{
    width: 20rem;
    height: 8rem;
    display: flex;
    text-align: center;
    align-items: center;
    cursor: pointer;
    .title{
        width: 100%;
        font-size: 1.8rem;
        font-family: 'CN_Medium';
        font-weight: 500;
        color: #4F4F4F;
        line-height: 2rem;
        text-align: center;
    }
}
.custom-list-item:hover{
    border-bottom: 2px solid #11A84F;
    color: #11A84F;
}
.custom-list-ischeck{
    border-bottom: 2px solid #11A84F;
    color: #11A84F;
}
.custon-title1{
    width: 139rem;
    text-align: justify ;
    margin:6rem 0 1.7rem  26.1rem;
    height: 2rem;
    font-size: 2rem;
    font-family: 'CN_Medium';
    font-weight: 500;
    color: #000000;
    line-height: 3rem;
}
.custom-img1{
    width: 139.5rem;
    height: 52rem;
    margin: auto;
    margin-top: 6rem;
}
.custom-box1{
    margin-top:6rem;
    width: 139rem;
    margin: auto;
    .title1{
        // height: 2rem;
        font-size: 2rem;
        font-family: 'CN_Medium';
        font-weight: 500;
        color: #000000;
        line-height: 3rem;
        text-align: justify ;
        margin-top: 6rem;
    }
    .title2{
        width: 139.5rem;
        height: 16rem;
        font-size: 1.6rem;
        font-family: 'CN_Normal';
        font-weight: 400;
        color: #666666;
        line-height: 3rem;
        text-align: justify ;
        margin-top: 3.1rem;
    }
    .img1{
        width: 139.5rem;
        height: 52.9rem;
        margin-top: 4rem;
    }
    .box2-1{
        width: 139rem;
        height: 30rem;
        margin-bottom: 1rem;
        /*设置当前元素为flex模式*/
        display: flex;
        /*行元素默认不折行，设置为折行*/
        flex-wrap: wrap;
        justify-content: space-between;
        .big-card{
            .card{
                transition: all 1s;
                width: 27rem;
                height: 22rem;
                background: #FFFFFF;
                box-shadow: 0px 0px 12px 0px rgba(233,233,233,0.6);
                overflow: hidden;
                img{
                    // margin: auto;
                    margin-top: 4rem;
                }
                .title2-1{
                    height: 2rem;
                    font-size: 2rem;
                    font-family: 'CN_Medium';
                    font-weight: 500;
                    color: #000000;
                    line-height: 3rem;

                    margin: 3rem 0 0 0;
                }
                .title2-2{
                    width: 21rem;
                    height:0;
                    font-size: 1.6rem;
                    // transform: scale(0);
                    font-family: 'CN_Regular';
                    font-weight: 400;
                    color: #4F4F4F;
                    line-height: 3rem;
                    overflow: hidden;
                    display: flex;
                    align-items: center;

                    margin: auto;
                    margin-top: 1.5rem;
                    text-align: justify ;
                }
            } 
        }
        .big-card:hover>.card img{
            // transform: scale(0);
            display: none;
            transition: all 1s;
        }
        .big-card:hover>.card .title2-1{
            display: none;
        }
        .big-card:hover>.card{
            // height: 35.9rem;
            transform: rotateY(180deg) scaleX(-1);
            transition: all 1.5s;
        }
        .big-card:hover>.card .title2-2{
            height:18.5rem;
            // overflow: auto;
            padding-bottom: 2rem;
            // transform: scale(1);
            transition: all 0s;
        }

    }
    .box2-2{
        width: 139rem;
        margin-bottom: 1rem;
        /*设置当前元素为flex模式*/
        display: flex;
        /*行元素默认不折行，设置为折行*/
        flex-wrap: wrap;
        justify-content: space-between;
        .card{
            width: 69.2rem;
            height: 21rem;
            display: flex;
            img{
                // margin: auto;
                width: 4rem;
                height: 4rem;
                margin: 3rem 0 0 2rem;
            }
            .content{
                margin: 2rem 0 0 3.3rem;
                .title1{
                    height: 2rem;
                    font-size: 2rem;
                    font-family: 'CN_Medium';
                    font-weight: 500;
                    color: #000000;
                    line-height: 3rem;
                    margin: 1rem 0 0 0;
                }
                .title2{
                    width: 56.1rem;
                    font-size: 1.6rem;
                    font-family: 'CN_Regular';
                    font-weight: 400;
                    color: #4F4F4F;
                    line-height: 3rem;
                    margin: 2rem 0 0 0;
                }
            }
        }

    }
    .custom-more{
        width: 14rem;
        height: 4.6rem;
        border: 1px solid #11A84F;
        margin: auto;
        display: flex;
        text-align: center;
        align-items: center;
        cursor: pointer;

        margin-top: 4.5rem;
        span{
            width: 6.4rem;
            height: 3rem;
            font-size: 1.6rem;
            font-family: 'CN_Normal';
            font-weight: 400;
            color: #11A84F;
            line-height: 3rem;
            margin: auto;
        }
    }
}
</style>
